"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.LinkTargetAttributor = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _reactQuill = require("react-quill");
var Parchment = _reactQuill.Quill.import('parchment');
var Link = _reactQuill.Quill.import('formats/link');

/**
 * This Attributor class overrides the canAdd function to enforce that target attributes can only be added to links.
 *
 * @extends Parchment.Attributor.Attribute
 */
var LinkTargetAttributor = exports.LinkTargetAttributor = /*#__PURE__*/function (_Parchment$Attributor) {
  (0, _inheritsLoose2.default)(LinkTargetAttributor, _Parchment$Attributor);
  function LinkTargetAttributor(attrName, keyName, options) {
    return _Parchment$Attributor.call(this, attrName, keyName, options) || this;
  }

  // override parchment's default canAdd function with our own
  // to enforce that target attributes can only be added to links
  var _proto = LinkTargetAttributor.prototype;
  _proto.canAdd = function canAdd(node) {
    return node.tagName === 'A';
  };
  return LinkTargetAttributor;
}(Parchment.Attributor.Attribute);
/**
 * A custom inline-level Blot for inserting links supported by the RichTextEditor.
 * Designed to extend and support Quill's built-in Link blot.
 * The link format returns the value of the href attribute of its anchor tag.
 *
 * To add to the editor, register this Blot with Quill using the register API.
 *
 * @extends Link
 */
var CustomLink = /*#__PURE__*/function (_Link) {
  (0, _inheritsLoose2.default)(CustomLink, _Link);
  function CustomLink() {
    return _Link.apply(this, arguments) || this;
  }
  /**
   * Creates a link DOM node with href and target attributes
   *
   * @param {string/object} value - an object containing the url and the target of the link
   * @returns node - the corresponding DOM node for the link
   */
  CustomLink.create = function create(value) {
    var _value$href;
    /**
     * super.create(url) assigns the following attributes to the anchor element:
     *  href: this.sanitize(url)
     *  rel: noopener noreferrer - prevents performance issues and security vulnerabilities when using the _blank target
     *  target: _blank
    */
    var node = _Link.create.call(this, value);

    // super.create uses a url scheme whitelist: ['http', 'https', 'mailto', 'tel', 'sms']
    // and alters the url if the scheme is not found in the whitelist
    // as a workaround, we set the attribute here ourselves
    node.setAttribute('href', (_value$href = value.href) != null ? _value$href : value);

    // remove the default target attribute
    node.removeAttribute('target');
    node.addEventListener('click', function (event) {
      var _node$firstChild;
      event.preventDefault();

      // some pasted images can be wrapped in links
      // in this case on click we don't want to navigate to the link
      // but we want to be able to resize the image
      if (((_node$firstChild = node.firstChild) == null ? void 0 : _node$firstChild.tagName) !== 'IMG') {
        node.setAttribute('rel', 'external');
        window.open(node.getAttribute('href'), value.target);
      }
    });
    return node;
  };
  return CustomLink;
}(Link);
CustomLink.tagName = 'A';
CustomLink.blotName = 'link';
var _default = exports.default = CustomLink;